import * as React from "react";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import { Link } from 'react-router-dom';
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import MiniSpinner from "../common/MiniSpinner";
import DirectScheduleButton from "../appointments/DirectScheduleButton";
import FavoritedLabel from "./FavoritedLabel";

class MyDirectScheduleProviders extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            detailsRequested: false
        };

        if (!this.props.providerNpiList) {
            // direct schedule providers were never requested s/b on login, but gets lost on hard refresh
            this.props.getProviderList();
        }
        else {
            if (this.props.providerNpiList.length > 0) {
                const model = {
                    ids: props.providerNpiList.join("|")
                };
                this.props.getProviderDetails(model);
            }
        }

    }

    componentDidMount() {
        logUI("MBHWeb.UI.MyDirectScheduleProviders.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentWillReceiveProps(props) {
        if ((props.providerNpiList && props.providerNpiList.length > 0) && (!this.props.providerDetails || this.props.providerDetails.length === 0) && !this.state.detailsRequested) {
            this.setState({ detailsRequested: true });

            const model = {
                ids: props.providerNpiList.join("|")
            };
            this.props.getProviderDetails(model);
        }
    }

    providerCard(provider, index) {
        let location = null;
        let more = 0;
        if (provider.locations.length > 0) {
            location = provider.locations[0];
            more = provider.locations.length - 1;
        }
        let phone = provider.consumerCallCenterNumber;
        if (location && location.locationPhone && (!phone || phone === "")) {
            phone = location.locationPhone;
        }
        
        return (
            <div className="col-12 col-lg-6" key={index}>
                <div className="card docs">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12 finger" onClick={() => { this.navToProvider(provider.npi) }}>
                                <div className="docs__img-container">
                                    <img alt={Tools.trimComma(provider.displayName) + " photo"} src={provider.photo || "/images/profile-pic.png"} />
                                </div>
                                <div className="docs__info-container">
                                    <div className="col-12">

                                        <div className="docs__info-container--name">
                                            {Tools.trimComma(provider.displayName)}
                                        </div>
                                        <div className="docs__info-container--specialty">
                                            {provider.specialties.map((specialty) => {
                                                return specialty.Specialty;
                                            }).join(",")}
                                        </div>
                                        <div className="docs__info-container--details">
                                            <div className="details-icon-prepend">
                                                <div className="icon-col"><span className="icon-address" /></div>
                                                <div className="details-col">
                                                    <div>{location && location.locationCity + ", " + location.locationState + "   " + (more > 0 ? "(+" + more + " more)" : "")}</div> {/* Doc's main city and state + however many other locations they work at. Link to the doctor's details page. */}
                                                </div>
                                            </div>
                                            <div className="details-icon-prepend">
                                                <div className="icon-col"><span className="icon-phone" /></div>
                                                <div className="details-col">
                                                    <div>{phone}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <FavoritedLabel NPI={provider.npi} />
                                        <DirectScheduleButton npi={provider.npi} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
    
    render() {

        const providers = this.props.providerDetails;

        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-12">
                        <h1 className="page-heading">My Doctors</h1>
                    </div>
                </div>
                {
                    (this.props.providerListPending || this.props.providerDetailsPending) ?
                        <MiniSpinner />
                        : providers.length === 0 ?
                            <div className="row"><div className="col-12 no-favorites">No doctors are available to schedule.</div></div>
                            :
                            <React.Fragment>
                                <div className="row row-card-eq">
                                {
                                    providers.map((provider, index) => {
                                        return this.providerCard(provider, index);
                                    })
                                }
                                </div>
                            </React.Fragment>
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        providerList: state.directScheduling.providerList,
        providerNpiList: state.directScheduling.providerNpiList,
        providerListSuccess: state.directScheduling.providerListSuccess,
        providerListPending: state.directScheduling.providerListPending,
        providerDetails: state.providers.providerDetails,
        providerDetailsPending: state.providers.detailsPending,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getProviderList: () => dispatch({ type: types.DIRECT_SCHEDULING_PROVIDER_LIST }),
        getProviderDetails: (model) => dispatch({ type: types.PROVIDER_DETAIL, searchModel: model })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyDirectScheduleProviders);
